/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ fee: NonNullable<unknown> }} Retain_Your_Capital_DominateInputs */

const en_retain_your_capital_dominate = /** @type {(inputs: Retain_Your_Capital_DominateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Retain your capital. Dominate your market. Start with 10% fees and scale to 7.5% or 5% as you grow.`)
};

const es_retain_your_capital_dominate = /** @type {(inputs: Retain_Your_Capital_DominateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Retén tu capital. Domina tu mercado. Empieza gratis y pasa a Sovereign cuando estés listo para el ${i?.fee}% en comisiones.`)
};

const fr_retain_your_capital_dominate = /** @type {(inputs: Retain_Your_Capital_DominateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Conservez votre capital. Dominez votre marché. Commencez gratuitement et passez à Sovereign lorsque vous êtes prêt pour des frais à ${i?.fee} %.`)
};

const de_retain_your_capital_dominate = /** @type {(inputs: Retain_Your_Capital_DominateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Behalte dein Kapital. Dominiere deinen Markt. Starte kostenlos und wechsle zu Sovereign, wenn du bereit bist für ${i?.fee}% Gebühren.`)
};

const ja_retain_your_capital_dominate = /** @type {(inputs: Retain_Your_Capital_DominateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`資本を保持し、市場を支配しましょう。無料で始めて、準備ができたら手数料${i?.fee}%のSovereignに移行できます。`)
};

const zh_retain_your_capital_dominate = /** @type {(inputs: Retain_Your_Capital_DominateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`保留您的资金。主导您的市场。免费起步，准备好后即可升级至 Sovereign，享受 ${i?.fee}% 手续费。`)
};

const ar_retain_your_capital_dominate = /** @type {(inputs: Retain_Your_Capital_DominateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`احتفظ برأس مالك. هيمن على سوقك. ابدأ مجانًا وانتقل إلى Sovereign عندما تكون مستعدًا لرسوم ${i?.fee}%.`)
};

const id_retain_your_capital_dominate = /** @type {(inputs: Retain_Your_Capital_DominateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pertahankan modal Anda. Kuasai pasar Anda. Mulai dengan biaya 10% dan tingkatkan ke 7.5% atau 5% seiring pertumbuhan Anda.`)
};

const it_retain_your_capital_dominate = /** @type {(inputs: Retain_Your_Capital_DominateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Conserva il tuo capitale. Domina il tuo mercato. Inizia gratis e passa a Sovereign quando sei pronto per le commissioni al ${i?.fee}%.`)
};

const ru_retain_your_capital_dominate = /** @type {(inputs: Retain_Your_Capital_DominateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Сохраняйте капитал. Доминируйте на рынке. Начните бесплатно и переходите на Sovereign, когда будете готовы к комиссии ${i?.fee}%.`)
};

const pt_retain_your_capital_dominate = /** @type {(inputs: Retain_Your_Capital_DominateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Retenha o seu capital. Domine o seu mercado. Comece grátis e mude para Sovereign quando estiver pronto para taxas de ${i?.fee}%.`)
};

const ko_retain_your_capital_dominate = /** @type {(inputs: Retain_Your_Capital_DominateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`자본을 지키고 시장을 장악하세요. 무료로 시작하고 ${i?.fee}%의 수수료를 낼 준비가 되면 Sovereign으로 전환하세요.`)
};

/**
* | output |
* | --- |
* | "Retain your capital. Dominate your market. Start with 10% fees and scale to 7.5% or 5% as you grow." |
*
* @param {Retain_Your_Capital_DominateInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const retain_your_capital_dominate = /** @type {((inputs: Retain_Your_Capital_DominateInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Retain_Your_Capital_DominateInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_retain_your_capital_dominate(inputs)
	if (locale === "es") return es_retain_your_capital_dominate(inputs)
	if (locale === "fr") return fr_retain_your_capital_dominate(inputs)
	if (locale === "de") return de_retain_your_capital_dominate(inputs)
	if (locale === "ja") return ja_retain_your_capital_dominate(inputs)
	if (locale === "zh") return zh_retain_your_capital_dominate(inputs)
	if (locale === "ar") return ar_retain_your_capital_dominate(inputs)
	if (locale === "id") return id_retain_your_capital_dominate(inputs)
	if (locale === "it") return it_retain_your_capital_dominate(inputs)
	if (locale === "ru") return ru_retain_your_capital_dominate(inputs)
	if (locale === "pt") return pt_retain_your_capital_dominate(inputs)
	return ko_retain_your_capital_dominate(inputs)
});